module.exports = __webpack_public_path__ + "media/images/app/login/modal-login-background-04b71ef3f4120bea50845f70ae11129f.webp";